import { Link } from "react-router-dom";

export default function Projects() {
  return (
    <div>
      <h2 className="heading">Projects</h2>
      <div>
        <div className="subheading">
          Click on a project to find out more about my work.
        </div>
        <div className="projects">
          <div className="project">
            <Link to="/projects/icgc" target="blank" className="project-title">
              Imperial College Gliding Club
            </Link>
            {/* <img /> */}
            <div className="project-subtitle">Frontend project</div>
            <p className="project-description">
              A digital hub for the Imperial College Gliding Club, providing
              information and resources for both current members and those with
              a keen interest in gliding. The site follows a user-centric design
              philosophy, aimed at catering to users' preferences and
              behaviours.
              <br />
              <br />
              This project allowed me to combine my love for gliding and coding.
              I set out to create a frontend website that not only captured the
              essence of the sport to those interested in joining, but also
              catered to the needs of our current community
            </p>
          </div>
          <div className="project">
            <Link to="projects/mooz" target="blank" className="project-title">
              Mooz
            </Link>
            <div className="project-subtitle">Full stack project</div>
            <p className="project-description">
              A video interview platform which simulates real interview
              scenarios. Participants can choose from a list of interview
              questions, record their answers and playback their responses to
              evaluate and improve performance. It includes robust multi-layered
              user authentication using industry-standard secure protocols for
              users to have the ability to save videos and personal information
              securely.
              <br />
              <br />
              This project idea originated from a career workshop I attended at
              Imperial. Creating this platform allowed me to refine both
              technical coding abilities and the art of communication while I
              made my transition into the tech world full-time.
            </p>
          </div>
          {/* <div className="project">
            <Link
              to="projects/mindthegap"
              target="blank"
              className="project-title"
            >
              Mind The Gap
            </Link>
            <div className="project-subtitle">Full stack project</div>
            <p className="project-description">
              A web application that helps commuters avoid the last-minute
              platform scramble by showing real-time UK train departure
              information. It aims to reduce stress and bring clarity to the
              rush of daily travel.
              <br />
              <br />
              The idea came after one too many frantic dashes across Victoria
              Station. Having tried a few tools over the years, I wanted to
              build something tailored to the actual pain points I experienced.
              It was a fun project to bring to life — combining practical
              problem-solving with creative touches that reflect the quirks of
              UK commuting.
            </p>
          </div> */}
          <div className="project">
            <Link
              to="projects/retronet"
              target="blank"
              className="project-title"
            >
              Retro Net
            </Link>
            <div className="project-subtitle">Frontend project</div>
            <p className="project-description">
              A web application that lets you step back in time and explore your
              avourite websites as they appeared a decade ago. With just a
              click, you can rediscover the design, content, and nostalgia of
              the online world from the past.
            </p>
          </div>
          {/* <div className="project">
              <div className="project-title">Project 1</div>
              <div className="project-subtitle">Frontend/backend?</div>
              <p className="project-description">Project description</p>
            </div> */}
        </div>
      </div>
      <div>
        Check out{" "}
        <a
          href="https://github.com/jbkad"
          target="blank"
          className="highlight-2"
        >
          github/jbkad
        </a>{" "}
        for more projects!
      </div>
    </div>
  );
}
